import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getHamsKey } from '../../../services/product-to-hams-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint } from './standardToPremiumModal.entrypoint';

export function StandardToPremiumModal(): React.JSX.Element {
	const { product, cloudId } = useEditionAwareness();

	const entryPointParams = useMemo(
		() => ({ cloudId, hamsProductKey: getHamsKey(product) }),
		[cloudId, product],
	);

	const modalProps = useMemo(() => ({ width: 968 }), []);

	return (
		<ModalEntryPoint
			modalProps={modalProps}
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
